import { Navigate } from 'react-router-dom';

import UnauthorizedPage from '@occc-app/routes/Unauthorized';

import { useRetailerConnectUser } from '../hooks/use-retailer-connect-user.hook';
import RetailerNetworkListPage, {
  RetailerNetworkListPageGuard,
} from '../retailer-network-list-page';
import { routeCreator } from '../retailer-connect.utils';

const RetailerNetworkBasePage = () => {
  const { isRetailerNetworkSiteUserRole, retailerNetworkUserId, retailerNetworkId } =
    useRetailerConnectUser();

  return isRetailerNetworkSiteUserRole ? (
    retailerNetworkId && retailerNetworkUserId ? (
      <Navigate to={routeCreator.userDetails(retailerNetworkId, retailerNetworkUserId)} />
    ) : (
      <UnauthorizedPage />
    )
  ) : (
    <RetailerNetworkListPageGuard>
      <RetailerNetworkListPage />
    </RetailerNetworkListPageGuard>
  );
};

export default RetailerNetworkBasePage;
